export default __webpack_public_path__ + "static/media/879.aa67fabc.png";